import { createSlice } from '@reduxjs/toolkit';
import { authApi } from './auth.api';
import { User } from './types';

const defaultUser: User = {
  token: '',
  evotorExternalToken: '',
  login: '',
  name: '',
  id_con: '',
  refreshToken: '',
  id: 0,
  email: '',
  phone: '',
  notificationToken: undefined,
};

export interface AuthSlice {
  isAuth: boolean;
  authStatusMessage: string | null;
  user: User;
}

const initialState: AuthSlice = {
  isAuth: false,
  authStatusMessage: null,
  user: defaultUser,
};

const normalizeUser = (user: User): User => ({
  ...defaultUser,
  ...user,
  evotorExternalToken: user.evotorExternalToken ?? '',
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.isAuth = false;
      state.user = defaultUser;
    },
    clearAuthMessage: (state) => {
      state.authStatusMessage = null;
    },
  },
  extraReducers: (builder) => {
    const applyLoginPayload = (
      state: AuthSlice,
      payload: { status: boolean; message?: string; user?: User }
    ) => {
      if (!payload.status) {
        state.isAuth = false;
        state.authStatusMessage = (payload.message as string) ?? null;
        state.user = defaultUser;
      } else if (payload.user) {
        state.user = normalizeUser(payload.user);
        state.isAuth = true;
        state.authStatusMessage = null;
      }
    };

    builder.addMatcher(authApi.endpoints.login.matchFulfilled, (state, { payload }) => {
      applyLoginPayload(state, payload);
    });
    builder.addMatcher(authApi.endpoints.evotorLogin.matchFulfilled, (state, { payload }) => {
      applyLoginPayload(state, payload);
    });
    builder.addMatcher(
      authApi.endpoints.employeeRegistration.matchFulfilled,
      (state, { payload }) => {
        applyLoginPayload(state, payload);
      }
    );
    builder.addMatcher(authApi.endpoints.checkSession.matchFulfilled, (state, { payload }) => {
      if (!payload.status) {
        state.isAuth = false;
        state.authStatusMessage = 'Нет доступа';
        state.user = defaultUser;
      }
    });
  },
});

export const { logout, clearAuthMessage } = authSlice.actions;
export default authSlice.reducer;
